import './UserProfile.scss';
import { RootState } from '../../../Redux/Store';
import { useAppSelector } from '../../../Hooks/Hooks';
import ProfileCircle from '../ProfileCircle/ProfileCircle';
import { useContext, useEffect } from 'react';
import { AppContext } from '../../../Context/AppContext';
import CustomTooltip from '../../../Utils/CustomTooltip/CustomTooltip';
import { ECustomTooltipPlacement } from '../../../Utils/CustomTooltip/CustomTooltip.type';
import { TOOLTIP_MESSAGE } from '../../../Constants/Constants';
import { isB2BUser, isB2CUser } from '../../../Utils/App.utils';
import { isEntitled } from '../../../Utils/ContentOrConfigUtil';
import { EVENT, LEAD, SCREEN } from '../../../Constants/AnalyticsConstants';
import { fbLogEvent } from '../../../Helpers/FirebaseHelper';

interface IUserProfileProps {}

const UserProfile = (props: IUserProfileProps) => {
  const { isMobile } = useContext(AppContext);
  const { memberData } = useAppSelector((state: RootState) => state.member);
  const { contentStackData, configTableData } = useAppSelector(
    (state: RootState) => state.ContentOrConfig,
  );
  const roles = memberData?.member?.userApplicationDetails?.[0].roles.map((role: any) => {
    return `${role.roleName} `;
  });

  const firstName = memberData?.member?.firstName;
  const lastName = memberData?.member?.lastName;
  const email = memberData?.member?.email;
  const mobileNumber = memberData?.member?.mobileNumber;
  const driverId = memberData?.member?.userApplicationDetails?.[0].attributes.DriverId;
  const supplierId = memberData?.member?.supplierId;

  useEffect(() => {
    const divElement = document.querySelector('.B2B_Edit');

    if (divElement) {
      const anchorElement = divElement.querySelector('a');

      if (anchorElement) {
        anchorElement.addEventListener('click', () => {
          handleAnchorClick(anchorElement);
        });
      }
      return () => {
        if (anchorElement) {
          anchorElement?.removeEventListener('click', () => null);
        }
      };
    }
  }, []);
  const handleAnchorClick = (anchorElement?: any) => {
    fbLogEvent(EVENT.UE_MY_PROFILE_EDIT_REDIRECTION, {
      screen: SCREEN.MY_PROFILE,
      lead: LEAD.MY_PROFILE,
    });
  };
  return (
    <>
      {isEntitled(
        memberData?.member,
        configTableData?.FPO_APP_CONFIG?.APP_INIT,
        'profile',
        'addressEdit',
      ) &&
        isB2BUser(memberData?.memberAzureTenantInfo) && (
          <div
            className="B2B_Edit"
            dangerouslySetInnerHTML={{
              __html:
                contentStackData?.accordion_content?.find((item: any) =>
                  item?.title?.includes('Change of Address'),
                )?.content || '',
            }}
          />
        )}
      {isEntitled(
        memberData?.member,
        configTableData?.FPO_APP_CONFIG?.APP_INIT,
        'profile',
        'profileEdit',
      ) &&
        isMobile &&
        isB2CUser(memberData?.memberAzureTenantInfo) && (
          <CustomTooltip
            message={TOOLTIP_MESSAGE}
            isOnClick={true}
            placement={ECustomTooltipPlacement?.top}
            slug={'Edit Button'}
          >
            <button
              className="B2C_Edit"
              onClick={() => handleAnchorClick()}
              aria-label="Edit Profile"
            >
              <img src="/oo/assets/icon/Edit-icon.svg" alt="edit icon" />
              <span>Edit</span>
            </button>
          </CustomTooltip>
        )}
      <div
        className={`Profile_Wrapper ${
          isEntitled(
            memberData?.member,
            configTableData?.FPO_APP_CONFIG?.APP_INIT,
            'profile',
            'addressEdit',
          ) && isB2BUser(memberData?.memberAzureTenantInfo)
            ? 'mt-2'
            : ''
        }`}
      >
        <div className="Name_Row">
          <div className="label">
            {firstName || 'User'} {lastName}
          </div>
          {isEntitled(
            memberData?.member,
            configTableData?.FPO_APP_CONFIG?.APP_INIT,
            'profile',
            'profileEdit',
          ) &&
            !isMobile &&
            isB2CUser(memberData?.memberAzureTenantInfo) && (
              <CustomTooltip
                message={TOOLTIP_MESSAGE}
                isOnClick={true}
                placement={ECustomTooltipPlacement?.top}
                slug={'Edit Button'}
              >
                <button
                  className="B2C_Edit"
                  onClick={() => handleAnchorClick()}
                  aria-label="Edit Profile"
                >
                  <img src="/oo/assets/icon/Edit-icon.svg" alt="edit icon" />
                  <span>Edit</span>
                </button>
              </CustomTooltip>
            )}
        </div>
        <div className="Details_Row">
          <div className="Left_Col">
            <ProfileCircle name={`${firstName} ${lastName}`} />
          </div>
          <div className="Right_Col">
            <p className="Disclaimer">*All fields are required</p>
            <div data-testid="details-list" className="Details_List">
              <div className="Detail_Item">
                <span className="Label">Role</span>
                <span className="Value">{roles || ''}</span>
              </div>
              <div className="Detail_Item">
                <span className="Label">First Name</span>
                <span className="Value">{firstName || ''}</span>
              </div>
              <div className="Detail_Item">
                <span className="Label">Last Name</span>
                <span className="Value">{lastName || ''}</span>
              </div>
              <div className="Detail_Item">
                <span className="Label">Email Address</span>
                <span className="Value">{email || ''}</span>
              </div>
              <div className="Detail_Item">
                <span className="Label">Personal Mobile Number</span>
                <span className="Value">{mobileNumber || ''}</span>
              </div>
              <div className="Detail_Item">
                <span className="Label">Driver No</span>
                <span className="Value">{driverId || ''}</span>
              </div>
              <div className="Detail_Item">
                <span className="Label">Supplier ID</span>
                <span className="Value">{supplierId || ''}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserProfile;
